module.exports = __webpack_public_path__ + "img/29_7.679b723e.png";